// Categories may have separate global and historical IDs after migration.
// Keep both sets of icons, but show a category name only once in product views.
export const groupPictograms = (categories, pictograms, uncategorizedLabel) => {
  const byId = new Map(categories.map(category => [category.id, category]));
  const byName = new Map();
  const groups = [];
  for (const category of categories) {
    const name = category.name.trim();
    if (!byName.has(name)) {
      const group = { id: category.id, name: category.name, items: [] };
      groups.push(group);
      byName.set(name, group);
    }
  }
  const other = [];
  for (const pictogram of pictograms) {
    const category = byId.get(pictogram.category_id);
    if (category) byName.get(category.name.trim()).items.push(pictogram);
    else other.push(pictogram);
  }
  if (other.length) groups.push({ id: null, name: uncategorizedLabel, items: other });
  return groups.filter(group => group.items.length);
};